import React, { useState } from "react";
import { PALETTE } from "../../common/ThemeConstants";

import Card from "react-bootstrap/Card";

export default function FeatureCard({
  cover,
  text,
  height = 200,
  width = 200,
}) {
  const [isCardHover, setIsCardHover] = useState(false);

  const backgroundColor = PALETTE.LIGHTGRAYTRANSPARENT; // isCardHover? PALETTE.WHITE : PALETTE.LIGHTGRAY
  return (
    <Card
      onMouseEnter={() => setIsCardHover(true)}
      onMouseLeave={() => setIsCardHover(false)}
      className={"shadow-sm text-center m-auto"}
      style={{
        backgroundColor: backgroundColor,
        border: "0px solid",
        width: width,
        height: height,
      }}
    >
      <Card.Img src={cover} alt={text} />
      <Card.ImgOverlay className="py-4">
        <p style={{ color: PALETTE.DARKGRAY }}>{text}</p>
      </Card.ImgOverlay>
    </Card>
  );
}
